<template>
    <jt-doughnut-chart
      centralTitleConst="DASHBOARD_CONSUMER_UNIT"
      :data="doughnutData"
      :shouldShowLegend="true"
      :shouldShowLabelParts="false"
      :shouldShowValueInLabelParts="false"
      :shouldShowPercentageInLabelParts="true"
    />
</template>
<script>
import JtDoughnutChart from 'src/components/charts/JtDoughnutChart.vue'
import JtCardDefault from 'src/components/dashboard/dashboard-card-components/base/JtCardDefault.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'

@Component({
  name: 'ConsumerUnit',
  components: {
    JtCardDefault,
    JtDoughnutChart
  }
})
export default class ConsumerUnit extends Vue {
  isLoadingDoughnut = false;

  doughnutData = [];
  currentDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  };

  async created () {
    await this.onChangeSelectDoughnut(this.currentDate)
  }

  async getDoughnutData (date) {
    const { registros } = await repository.resolveDatatableModel(
      'consumerUnit.hql',
      {
        grid: 'consumerUnitSum',
        month: date.month,
        year: date.year
      }
    )

    return registros
  }

  async onChangeSelectDoughnut (newValue) {
    this.isLoadingDoughnut = true
    this.doughnutData = await this.getDoughnutData(newValue)

    setTimeout(() => {
      this.isLoadingDoughnut = false
    }, 500)
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';
</style>
